import React from "react";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import ImgShellFiloPlatform from "../../assets/images/shell-filo-platform.jpeg";
import ImgShellFiloPlatform1 from "../../assets/images/shell-filo-platform-1.jpg";
import ImgFVTS from "../../assets/images/fleet-vehicle-tracking-system-shell-filoplatform-premium.jpg";
import { useLocation } from "react-router-dom";
import { products } from "../../data/products";
import ImgCityHd2 from "../../assets/images/city-hd-2.jpg";
import ImgCityHd3 from "../../assets/images/city-hd-3.jpg";
import ImgCityHd4 from "../../assets/images/city-hd-4.jpg";
import ImgCityHd5 from "../../assets/images/city-hd-5-resized.jpg";
import TTSForm from "../../components/common/TTSForm";
export default function AracTakipSistemi() {
  const pageImage = products.find(
    (p) => p.link === window.location.pathname
  )?.img;

  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Ara&#231; Takip Sistemi</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Ara&#231; Takip Sistemi</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Ara&#231; Takip Sistemi</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img src={pageImage ?? ""} />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h3>Shell FiloPlatform Nedir?</h3>

                  <p>
                    <b>
                      Shell Taşıt Tanıma Sistemi ile akaryakıt t&uuml;ketiminde
                      kontrol ile tanıştırdığımız şirketler, Shell Filo
                      Ara&ccedil; Takip Sistemi sayesinde şimdi de filo
                      y&ouml;netiminde kontrol ile tanışıyor!
                    </b>
                  </p>

                  <h4>Filonuzun Anlık Kontrol&uuml;</h4>

                  <p>
                    Gelişmiş harita hizmetleri, lokasyon ve zaman bazlı
                    analizler ile filo ara&ccedil;ları i&ccedil;in doğru
                    planlama yapabilir ve filonuzu etkili bir bi&ccedil;imde
                    y&ouml;netebilirsiniz.
                  </p>

                  <h4>Verimlilik</h4>

                  <p>
                    Sistemdeki TTS entegrasyonu sayesinde filonuzun yakıt
                    t&uuml;ketim raporlarını dilediğiniz zaman alabilir, toplam
                    yakıt, ortalama yakıt t&uuml;ketim bilgilerine kolayca
                    ulaşabilir ve raporlayabilirsiniz.
                  </p>

                  <h4>Kullanımı Kolay</h4>

                  <p>
                    Son teknoloji yazılımlar ile her aşamada kullanıcı dostu bir
                    portal olup filonuzu internet bağlantısı olan t&uuml;m
                    tablet veya cep telefonları &uuml;zerinden 7/24 ara&ccedil;
                    takip edebilirsiniz.
                  </p>

                  <h4>Akıllı ve Emniyet S&uuml;r&uuml;ş D&ouml;nemi</h4>

                  <p>
                    Her km&rsquo;de detaylı analiz ile s&uuml;r&uuml;ş ihlalleri
                    anlık ve s&uuml;rekli olarak &ouml;l&ccedil;&uuml;mlenir ve
                    s&uuml;r&uuml;c&uuml; davranışları değerlendirilir.
                    S&uuml;r&uuml;c&uuml; davranışlarının iyileşmesi ile kaza
                    oranları azalır.
                  </p>

                  <h4>Ekstra Tasarruf</h4>

                  <p>
                    Ara&ccedil; tipi, rota ve s&uuml;r&uuml;c&uuml;
                    &ouml;zelliklerine g&ouml;re filolarda verimlilik sağlayıp
                    filoların &ouml;mr&uuml;n&uuml; uzatarak bakım ve kullanım
                    maliyetlerinden de ekstra tasarruf sağlanmasına yardımcı
                    olur.
                  </p>

                  <p>
                    <a
                      className="file"
                      href="/file/shell-filoplatform-brosur.pdf"
                      target="_blank"
                    >
                      Shell FiloPlatform Broş&uuml;r&uuml;
                    </a>{" "}
                    <a
                      className="file"
                      href="/file/shell-filoplatform-sanofi-testimonial.pdf"
                      target="_blank"
                    >
                      Shell FiloPlatform Premium- Sanofi Referansı
                    </a>
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
            <div className="row mt-4">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                <div className="textCapsule">
                  <h3 className="bottomline">Shell FiloPlatform</h3>
                  <p>
                    <img
                      src={ImgCityHd2}
                      height="360"
                      width="640"
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </p>
                  <p>
                    Sisteme tanımlı araçlar harita üzerinden internet bağlantısı
                    olan tüm tablet veya cep telefonlarından 7/24
                    görüntülenebilir. Araç takip, araçların son konum verileri
                    ve hız bilgileri tespit edilebilir. İşe başlama ve bitirme
                    zamanları raporlanabilir, İş akışı düzenlenebilir. Özel
                    olarak araçların bakım, servis ve onarım gibi faaliyetlerini
                    takip edebilirsiniz.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="textCapsule">
                  <h3 className="bottomline">Shell FiloPlatform Premium</h3>
                  <p>
                    <img
                      src={ImgCityHd5}
                      height="360"
                      width="640"
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </p>
                  <p>
                    Shell FiloPlatform'un tüm özelliklerine ek olarak premium
                    pakette sürücü performansı, manevra tipleri, şerit
                    değiştirme, yol tutuşu viraj alma gibi sürüş aksiyonlarını
                    analiz ederek özelleştirilmiş iyileştirme raporları
                    paylaşır. Sürücülerin manevralarını ölçen gelişmiş
                    yazılımlar ile kaza riski oluşturan ve yakıt tüketimini
                    artıran sürüş ihlallerini annında tesğit ederek zamanında ve
                    dogru aksiyonların alınmasın ayardımcı olur. Sürüş
                    alışkanlıklarını değiştirerek güvenli ve verimli seyahat
                    kültürü oluşturur.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="row mt-4 center-xs">
              <div className="col-lg-12 col-xs">
                <div className="accardion">
                  <ul>
                    <li>
                      <span className="Button">Shell Filoplatform Nedir?</span>
                      <span className="Capsule">
                        <p>
                          Shell TTS ile entegre çalışan, araçlardaki GPS
                          sayesinde 7 gün 24 saat internet bağlantısı ile
                          bilgisayar, akıllı telefon, tablet üzerinden araçların
                          takip ve kontrol edilmesini sağlayan filo araç takip
                          sistemidir.
                        </p>
                        <p>
                          Shell FiloPlatform sayesinde araçların hızları,
                          izlemiş oldukları rotalar, duraklama yaptıkları
                          yerler, rölanti süreleri gibi çok sayıda bilgi,
                          haritalar üzerinden anlık ve geçmişe dönük olarak
                          izlenerek raporlanabilir. Sunduğı yakıt entegrasyonu
                          sayesinde araç bazlı yakıt tüketimleri analiz
                          edilebilir.
                        </p>
                        <p>
                          Shell FiloPlatform Premium paketinde ise sürücü
                          davranışlarına göre puanlama sistemi yapılmaktadır.
                          Böylece, Shell FiloPlatform Premium'un sunduğu Entegre
                          Sürüş Güvenliği Sistemi ile şirketlere araçların
                          nerede olduğu bilgisinin ötesinde, sürücü
                          davranışlarını ölçme ve araçların nasıl kullanıldığı
                          konusunda bilgi alma imkanı sunmaktadır.
                        </p>
                        <p>
                          Shell FiloPlatform Premium ürünü ile sürücü
                          davranışlarını takip edebildiğiniz için filonuzdaki
                          kaza sayısının azalmasını sağlar; böylece araçların
                          servis ve onarım, kasko ve trafik sigortası gibi
                          maliyetlerinin azalmasına yardımcı olur.{" "}
                        </p>
                        <p>
                          Filolara yakıt tasarrufu imkanıyla birlikte firmaların
                          araçlarının toplam sahip olma maliyetini ve
                          masraflarını azaltıyor.
                        </p>
                        <p>
                          Sektördeki araç takip sistemi fiyatlandırmasından
                          farklı olarak, firmalar operasyonel önceliklerine ve
                          ihtiyaçlarına uygun içerikleri göre kendilerine uygun
                          paketi seçilebilmektedir. Shell FiloPlatform 'un
                          sunduğu filo araç takip sistemi ile filoların
                          büyüklüğü fark etmeksizin, toplam filo maliyetlerinin
                          yönetilmesine yardım eder, güvenli sürüşü destekler ve
                          tasarruf fırsatları sunar.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell FiloPlatform'un Faydaları Nelerdir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Sürücü performansı doğrudan filo performansını
                          etkiler. İyi eğitilmiş ve teknoloji ile desteklenen
                          sürücülerden oluşan bir ekip, firmanın ana
                          faaliyetlerinin sürdürülmesinde kritik bir rol oynar.
                          Shell FiloPlatform, sürücü performansını analiz ederek
                          sürüş alışkanlıklarını değiştirmeyi amaçlar ve böylece
                          sürücülerde güvenli ve verimli seyahat kültürü
                          oluşturur.
                        </p>
                        <p>
                          Aynı zamanda işletmelerin veya filo yöneticilerinin
                          filo araç takibinde ihtiyaç duyduğu tüm verileri ve
                          çözümleri tek bir çatı altında toplayarak sunduğu
                          kullanıcı dostu portal sayesinde filo yönetimini
                          kolaylaştırır.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell FiloPlatform'un sunduğu filo araç takip sisteminin
                        özellikleri nelerdir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Shell FiloPlatform'un sunduğu teknoloji sayesinde hem
                          hızlanma, yavaşlama, yol tutuşu, şerit değiştirme,
                          viraj alma gibi sürüş aksiyonları hem de araçların
                          izlemiş olduğu rotalar takip edilerek çok sayıda
                          bilgi, haritalar üzerinden anlık veya geçmişe dönük
                          olarak izlenebilir ve raporlanabilir.
                        </p>
                        <p>
                          Sürücü manevralarını ölçen gelişmiş yazılımlar
                          sayesinde kaza riski oluşturan ve yakıt tüketimini
                          artıran sürüş ihlallerini anında tespit ederek
                          zamanında ve doğru aksiyonların alınmasına yardımcı
                          olur. Sürücü alışkanlıklarının değişmesiyle güvenli ve
                          verimli seyahat kültürü oluşturur.
                        </p>
                        <p>
                          Shell FiloPlatform'un sektördeki araç takip
                          sistemlerinden farklı olarak sağladığı yakıt
                          entegrasyon özelliği sayesinde araç bazlı yakıt
                          tüketimleri de analiz edilebilir.
                        </p>
                        <p>
                          Ek olarak firmalar, özel olarak araçların bakım,
                          servis, onarım gibi faaliyetleri de takip edilebilir.
                          Böylece filo araçlarının ömrünü uzatarak bakım ve
                          kullanım maliyetlerinden ekstra tasarruf sağlayabilir.
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--login--> */}
        <div className="container-fluid section login-section">
          <div className="container-fluid fullRow">
            <div className="row login start-md center-xs reverse">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 text">
                <div className="textCapsule">
                  <h3>Shell Filoplatform Müşteri Girişi</h3>
                  <p>
                    Sisteme tanımlı araçlar harita üzerinden internet bağlantısı
                    olan tüm tablet veya cep telefonlarından 7/24
                    görüntülenebilir
                  </p>

                  <a
                    href="https://shellfiloplatform.mobiliz.com.tr/#!/login"
                    className="loginBt"
                    target="_blank"
                  >
                    Shell FiloPlatform Müşteri Girişi – Mobiliz
                  </a>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 image"
                style={{
                  backgroundImage: `url(${ImgCityHd3})`,
                }}
              ></div>
            </div>
          </div>
        </div>
        {/* <!--/login--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
          
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
